import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, LoadingController, AlertController, Platform } from '@ionic/angular/lazy';
import { PersonService } from 'src/app/services/person.service';
import { Router } from '@angular/router';
import { APIService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { ObserverService } from 'src/app/services/observer.service';
import { CountryService } from 'src/app/services/country.service';
import { OrganisationService } from 'src/app/services/organisation.service';
import { CartService } from 'src/app/services/cart.service';
import { OrganisationPickerPage } from 'src/app/modals/organisation-picker/organisation-picker.page';
import { CountryPickerPage } from 'src/app/modals/country-picker/country-picker.page';
import { PricingTierService } from 'src/app/services/pricing-tier.service';
import { PermissionService } from 'src/app/services/permission.service';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-person-edit',
    templateUrl: './person-edit.page.html',
    styleUrls: ['./person-edit.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
}) 
export class PersonEditPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    params = {};
    @Input() person_id = null;
    person = null;;
    pricing_tiers = null;
    email_lists = null;
    organisation = null;
    modal_css_class = '';
    countries = null;

    mailing_address_country = null;
    mailing_address_subdivisions = null;
    mailing_address_requires_subdivision = false;
    mailing_address_subdivision_label = "State / Province / Region / County";
    mailing_address_subdivision_label_changed = false;
    mailing_address_requires_postal_code = false;
    mailing_address_postal_code_label = "Postcode";

    billing_address_country = null;
    billing_address_subdivisions = null;
    billing_address_requires_subdivision = false;
    billing_address_subdivision_label = "State / Province / Region / County";
    billing_address_subdivision_label_changed = false;
    billing_address_requires_postal_code = false;
    billing_address_postal_code_label = "Postcode";


    selectOptions: any = {
	    cssClass: "fullscreen-select"
    };

    // modal flags
    organisation_picker_modal_open = false;
    country_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private loadingController: LoadingController,
        private platform: Platform,
        private router: Router,
        private personService: PersonService,
        private authService: AuthService,
        private apiService: APIService,
        private observerService: ObserverService,
        private countryService: CountryService,
        private organisationService: OrganisationService,
        private cartService: CartService,
        private pricingTierService: PricingTierService,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
        }

        this.countryService.getCountries().then((countries) => {
            if(countries) {
                this.countries = countries;
            }
        })
        .catch(() => { });

        if(this.person_id) {


            this.loadData().then(() => {

                this.params["allow_on_account_payment_method"] = Boolean(this.person["allow_on_account_payment_method"]);
                this.params["first_name"] = "";
                this.params["last_name"] = "";
                this.params["job_title"] = "";
                this.params["email_address"] = "";
                this.params["pricing_tier_id"] = "";
                this.params['internal_note'] = "";
                this.params["mobile_phone_number"] = "";
                this.params["home_phone_number"] = "";
                this.params["work_phone_number"] = "";
                this.params["mailing_address_premises"] = "";
                this.params["mailing_address_line_1"] = "";
                this.params["mailing_address_line_2"] = "";
                this.params["mailing_address_locality"] = "";
                this.params["mailing_address_subdivision"] = "";
                this.params["mailing_address_postal_code"] = "";
                this.params["mailing_address_country_id"] = "";
                this.params["billing_address_premises"] = "";
                this.params["billing_address_line_1"] = "";
                this.params["billing_address_line_2"] = "";
                this.params["billing_address_locality"] = "";
                this.params["billing_address_subdivision"] = "";
                this.params["billing_address_postal_code"] = "";
                this.params["billing_address_country_id"] = "";
                this.params["organisation_id"] = "";

                if(this.person.first_name) {
                    this.params["first_name"] = this.person.first_name;
                } 
                if(this.person.last_name) {
                    this.params["last_name"] = this.person.last_name;
                }
                if(this.person.job_title) {
                    this.params["job_title"] = this.person.job_title;
                }
                if(this.person.email_address) {
                    this.params["email_address"] = this.person.email_address;
                }
                if(this.person.pricing_tier.id) {
                    this.params["pricing_tier_id"] = this.person.pricing_tier.id;
                }
                if(this.person.mobile_phone_number) {
                    this.params["mobile_phone_number"] = this.person.mobile_phone_number;
                }
                if(this.person.home_phone_number) {
                    this.params["home_phone_number"] = this.person.home_phone_number;
                }
                if(this.person.work_phone_number) {
                    this.params["work_phone_number"] = this.person.work_phone_number;
                }
                if(this.person.internal_note) {
                    this.params['internal_note'] = this.person.internal_note;
                }

                if(this.person.email_lists) {
                    this.params["email_list_ids"] = [];
                    if(this.person.email_lists) {
                        for(let i = 0; i < this.person.email_lists.length; i++) {
                            this.params["email_list_ids"][i] = this.person.email_lists[i].id;
                        }
                    }
                }

                if(this.person.organisation) {
                    this.params["organisation_id"] = this.person.organisation.id;
                    this.organisationService.getOrganisation(this.person.organisation.id,{}).then((organisation) => {
                        if(organisation) {
                            this.organisation = organisation;
                        }
                    })
                    .catch(() => { });
                }

                if(this.person.mailing_address) {
                    if(this.person.mailing_address.premises) {
                        this.params["mailing_address_premises"] = this.person.mailing_address.premises;
                    }
                    if(this.person.mailing_address.line_1) {
                        this.params["mailing_address_line_1"] = this.person.mailing_address.line_1;
                    }
                    if(this.person.mailing_address.line_2) {
                        this.params["mailing_address_line_2"] = this.person.mailing_address.line_2;
                    }
                    if(this.person.mailing_address.locality) {
                        this.params["mailing_address_locality"] = this.person.mailing_address.locality;
                    }
                    if(this.person.mailing_address.subdivision) {
                        this.params["mailing_address_subdivision"] = this.person.mailing_address.subdivision;
                    }
                    if(this.person.mailing_address.postal_code) {
                        this.params["mailing_address_postal_code"] = this.person.mailing_address.postal_code;
                    }
                    if(this.person.mailing_address.country) {

                        this.params["mailing_address_country_id"] = this.person.mailing_address.country.id;

                        this.loadMailingAddressCountry(this.person.mailing_address.country.id).then(() => {
                            this.mailingAddressCountryChanged();
                        })
                        .catch(() => { });

                    }
                }

                if(this.person.billing_address) {
                    if(this.person.billing_address.premises) {
                        this.params["billing_address_premises"] = this.person.billing_address.premises;
                    }
                    if(this.person.billing_address.line_1) {
                        this.params["billing_address_line_1"] = this.person.billing_address.line_1;
                    }
                    if(this.person.billing_address.line_2) {
                        this.params["billing_address_line_2"] = this.person.billing_address.line_2;
                    }
                    if(this.person.billing_address.locality) {
                        this.params["billing_address_locality"] = this.person.billing_address.locality;
                    }
                    if(this.person.billing_address.subdivision) {
                        this.params["billing_address_subdivision"] = this.person.billing_address.subdivision;
                    }
                    if(this.person.billing_address.postal_code) {
                        this.params["billing_address_postal_code"] = this.person.billing_address.postal_code;
                    }
                    if(this.person.billing_address.country) {

                        this.params["billing_address_country_id"] = this.person.billing_address.country.id;

                        this.loadBillingAddressCountry(this.person.billing_address.country.id).then(() => {
                            this.billingAddressCountryChanged();
                        })
                        .catch(() => { });

                    }
                }

            })
            .catch(() => { });

        }

        this.observerService.subscribe('pricing_tier_added|person_edit_modal', (pricing_tier) => {
            if(pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                pricing_tiers.push(pricing_tier);
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tier_deleted|person_edit_modal', (pricing_tier) => {
            if(pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                for(let i = 0; i < pricing_tiers.length; i++) {
                    if(pricing_tiers[i].id === pricing_tier["id"]) {
                        pricing_tiers.splice(i, 1);
                        break;
                    }
                }
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tier_updated|person_edit_modal', (pricing_tier) => {
            if(pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                for(let i = 0; i < pricing_tiers.length; i++) {
                    if(pricing_tiers[i].id === pricing_tier["id"]) {
                        pricing_tiers[i] = pricing_tier;
                        break;
                    }
                }
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tiers_changed|person_edit_modal', (pricing_tiers) => {
            if(pricing_tiers) {
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('network_status_changed|person_edit_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => {} ).catch(() => { });
                }
                else {
                    this.presentAlert("Offline", "You must be online to edit a person, please check your network connection and try again.");
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("pricing_tier_added|person_edit_modal");
        this.observerService.destroy("pricing_tier_deleted|person_edit_modal");
        this.observerService.destroy("pricing_tier_updated|person_edit_modal");
        this.observerService.destroy("pricing_tiers_changed|person_edit_modal");
        this.observerService.destroy("network_status_changed|person_edit_modal");
    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading person").then(() => {
                this.loadPerson().then(() => {
                    this.loading_spinner.message = "Loading pricing tiers";
                    this.pricingTierService.getPricingTiers().then((pricing_tiers) => {
                        if(pricing_tiers) {
                            this.sortPricingTiers(pricing_tiers);
                        }
                        this.loading_spinner.message = "Loading email lists";
                        this.loadEmailLists().then(() => {
                            this.loading_spinner.dismiss();
                            resolve();
                        })
                        .catch(() => {
                            this.loading_spinner.dismiss();
                            reject();
                        });
                    })
                    .catch(() => {
                        this.loading_spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    loadPerson() {
        return new Promise<void>((resolve, reject) => {
            this.person = null;
            this.authService.isLoggedIn().then(() => {
                this.apiService.getPerson(this.person_id).then((person: any) => {
                    if(person) {
                        this.person = person;
                    }
                    resolve();
                })
                .catch((error) => {
                    this.person = {};
                    if(error.status == 400) {
                        this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to retrieve a person.");
                    }
                    else if(error.status == 403) {
                        this.presentAlert("Insufficient permissions", "You don't have permission to view a person.");
                    }
                    else if(error.status == 404) {
                        this.presentAlert("Unavailable", "Unfortunately we're unable to retrieve a person at this time.");
                    }
                    else if(error.status == 0) {
                        this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    loadEmailLists() {
        return new Promise<void>((resolve, reject) => {
            this.email_lists = null;
            this.authService.isLoggedIn().then(() => {
                this.apiService.getEmailLists().then((email_lists) => {
                    if(email_lists) {
                        this.email_lists = email_lists;
                    }
                    resolve();
                })
                .catch((error) => {
                    if(error.status === 400) {
                        this.presentAlert('Unknown error', 'Unfortunately something went wrong when trying to retrieve a list of email lists.');
                    } 
                    else if(error.status === 403) {
                        this.presentAlert('Insufficient permissions', "You don't have permission to view a list of email lists.");
                    } 
                    else if(error.status == 404) {
                        this.presentAlert('Unavailable', "Unfortunately we're unable to retrieve a list of email lists at this time.");
                    }
                    else if(error.status == 0) {
                        this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    loadCountrySubdivisions(country_id) {
        return new Promise((resolve, reject) => {
            this.countryService.getCountrySubdivisions(country_id).then((subdivisions) => {
                resolve(subdivisions)
            })
            .catch(() => {
                reject();
            });
        });
    }

    sortPricingTiers(pricing_tiers) {
        pricing_tiers.sort((a, b) => {
            if(a['order'] < b['order']) { return -1; }
            if(a['order'] > b['order']) { return 1; }
            return 0;
        });
        this.pricing_tiers = pricing_tiers;
    }

    close() {
        this.modalController.dismiss();
    }

        loadMailingAddressCountry(country_id) {
        return new Promise<void>((resolve, reject) => {
            this.mailing_address_country = null;
            this.mailing_address_subdivisions = null;
            for(let i = 0; i < this.countries.length; i++) {
                if(this.countries[i].id == country_id) {
                    this.mailing_address_country = this.countries[i];
                    this.loadCountrySubdivisions(country_id).then((subdivisions: any) => {
                        if(subdivisions) {
                            this.mailing_address_subdivisions = subdivisions;
                        }
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
                    break;
                }
            }
        });
    }

    mailingAddressCountryChanged(){

        this.mailing_address_subdivision_label = "State / Province / Region / County";
        this.mailing_address_requires_subdivision = false;
        this.mailing_address_postal_code_label = "Postcode";
        this.mailing_address_requires_postal_code = false;

        if(this.params['mailing_address_country_id']) {

            if(this.mailing_address_country.subdivision_name) {
                this.mailing_address_subdivision_label = this.mailing_address_country.subdivision_name;
            }

            if(this.mailing_address_subdivisions && this.mailing_address_subdivisions.length != 0) {
                this.mailing_address_requires_subdivision = true;
            }

            if(this.mailing_address_country.postal_code_name) {
                this.mailing_address_postal_code_label = this.mailing_address_country.postal_code_name;
            }

            if(this.mailing_address_country.postal_code_required == true) {
                this.mailing_address_requires_postal_code = true;
            }

        }

        // NOTE: mailing_address_subdivision_label_changed is used to force UI to render correctly
        this.mailing_address_subdivision_label_changed = false;

        setTimeout(() => {
            this.mailing_address_subdivision_label_changed = true;
        }, 0);

    }

    loadBillingAddressCountry(country_id) {
        const promise = new Promise<void>((resolve, reject) => {
            this.billing_address_country = null;
            this.billing_address_subdivisions = null;
            for(let i = 0; i < this.countries.length; i++) {
                if(this.countries[i].id == country_id) {
                    this.billing_address_country = this.countries[i];
                    this.loadCountrySubdivisions(country_id).then((subdivisions: any) => {
                        if(subdivisions) {
                            this.billing_address_subdivisions = subdivisions;
                        }
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
                    break;
                }
            }
        });
        return promise;
    }

    billingAddressCountryChanged(){

        this.billing_address_subdivision_label = "State / Province / Region / County";
        this.billing_address_requires_subdivision = false;
        this.billing_address_postal_code_label = "Postcode";
        this.billing_address_requires_postal_code = false;

        if(this.params['billing_address_country_id']) {

            if(this.billing_address_country.subdivision_name) {
                this.billing_address_subdivision_label = this.billing_address_country.subdivision_name;
            }

            if(this.billing_address_subdivisions && this.billing_address_subdivisions.length != 0) {
                this.billing_address_requires_subdivision = true;
            }

            if(this.billing_address_country.postal_code_name) {
                this.billing_address_postal_code_label = this.billing_address_country.postal_code_name;
            }

            if(this.billing_address_country.postal_code_required == true) {
                this.billing_address_requires_postal_code = true;
            }

        }

        // NOTE: billing_address_subdivision_label_changed is used to force UI to render correctly
        this.billing_address_subdivision_label_changed = false;

        setTimeout(() => {
            this.billing_address_subdivision_label_changed = true;
        }, 0);

    }

    update() {

        let validated = true;
        let email_address_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if(this.params['first_name'] == null || this.params['first_name'].trim() === "") {
            this.presentAlert("First name required", "");
            validated = false;
        }
        else if(this.params['last_name'] == null || this.params['last_name'].trim() === "") {
            this.presentAlert("Last name required", "");
            validated = false;
        }
        else if(this.params['email_address'] && !email_address_regex.test(String(this.params['email_address']).toLowerCase())) {
            this.presentAlert("Invalid email address", "");
            validated = false;
        }

        if(validated) {

            this.updatePerson().then(() => {
                this.modalController.dismiss();
            });

        }
    }

    updatePerson() {
        return new Promise<void>((resolve, reject) => {
            this.presentSpinner("Updating person").then(() => {
                this.authService.isLoggedIn().then(() => {
                    this.apiService.updatePerson(this.person_id, this.params).then((person) => {
                        if(person) {
                            this.personService.updatePerson(person).then(() => {
                                this.cartService.get().then((cart) => {
                                    if(cart['person'] ) {
                                        if(cart['person'].id == this.person_id) {
                                            this.cartService.updatePerson(person['id']).then(() => {
                                                if(person['organisation']) {
                                                    this.cartService.updateOrganisation(person['organisation'].id).then(() => {}).catch(() => {});
                                                } 
                                                else {
                                                    this.cartService.removeOrganisation().then(() => {}).catch(() => {});
                                                }
                                            });
                                        }
                                    }
                                })
                                .catch(() => { });
                            })
                            .catch(() => { });
                        }
                        this.spinner.dismiss();
                        resolve();
                    })
                    .catch((error) => {
                        if(error) {
                            if(error.status === 400) {
                                this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to update this person.");
                            } 
                            else if(error.status === 403) {
                                this.presentAlert("Insufficient permissions", "You don't have permission to update this person.");
                            } 
                            else if(error.status == 404) {
                                this.presentAlert("Unavailable", "Unfortunately we're unable to update this person at this time.");
                            }
                            else if(error.status == 0) {
                                this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                            }
                        }
                        this.spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                        window.location.reload();
                    });
                });
            });
        });
    }

    async presentOrganisationPickerModal() {
        if(!this.organisation_picker_modal_open) {
            this.organisation_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: OrganisationPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    organisation_id: (this.params['organisation_id'] ? this.params['organisation_id'] : null)
                }
            });
            modal.onDidDismiss().then((data) => {
                this.organisation_picker_modal_open = false;
                if(data.data) {
                    if(data.data['picker_action'] == "organisation_deleted") {
                        this.params["organisation_id"] = "";
                        this.organisation = null;
                    }
                    else {
                        this.params["organisation_id"] = data.data['organisation_id'];
                        this.organisationService.getOrganisation(data.data['organisation_id'],{}).then((organisation) => {
                            if(organisation) {
                                this.organisation = organisation;
                            }
                        })
                        .catch(() => { });
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentMailingAddressCountryPickerModal() {
        if(!this.country_picker_modal_open) {
            this.country_picker_modal_open = true;
            let existing_mailing_address_country_id = "";
            if(this.params['mailing_address_country_id']) {
                existing_mailing_address_country_id = this.params['mailing_address_country_id'];
            }
            const modal = await this.modalController.create({
                component: CountryPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    country_id: (this.params['mailing_address_country_id'] ? this.params['mailing_address_country_id'] : "")
                }
            });
            modal.onDidDismiss().then((data) => {
                this.country_picker_modal_open = false;
                if(data.data) {
                    if(data.data === "country_deleted") {
                        this.params["mailing_address_country_id"] = "";
                        this.mailing_address_country = null;
                        this.mailingAddressCountryChanged();
                    } 
                    else {
                        if(data.data['country_id'] != existing_mailing_address_country_id) {
                            this.params["mailing_address_country_id"] = data.data['country_id'];
                            this.loadMailingAddressCountry(data.data['country_id']).then(() => {
                                this.mailingAddressCountryChanged();
                            })
                            .catch(() => { });
                        }
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

     async presentBillingAddressCountryPickerModal() {
        if(!this.country_picker_modal_open) {
            this.country_picker_modal_open = true;
            let existing_billing_address_country_id = "";
            if(this.params['billing_address_country_id']) {
                existing_billing_address_country_id = this.params['billing_address_country_id'];
            }
            const modal = await this.modalController.create({
                component: CountryPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    country_id: (this.params['billing_address_country_id'] ? this.params['billing_address_country_id'] : null)
                }
            });
            modal.onDidDismiss().then((data) => {
                this.country_picker_modal_open = false;
                if(data.data) {
                    if(data.data === "country_deleted") {
                        this.params["billing_address_country_id"] = "";
                        this.billing_address_country = null;
                        this.billingAddressCountryChanged();
                    }
                    else {
                        if(data.data['country_id'] != existing_billing_address_country_id) {
                            this.params["billing_address_country_id"] = data.data['country_id'];
                            this.loadBillingAddressCountry(data.data['country_id']).then(() => {
                                this.billingAddressCountryChanged();
                            })
                            .catch(() => { });
                        }
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

}
